import { Selector } from '@ngxs/store';
import { AuthState, AuthStateModel, SignupErrors, UserLogged } from './auth.state';

export class AuthSelector {
  @Selector([AuthState])
  /** No error until something fails, which is what the state starts at. */
  static signInError(state: AuthStateModel): SignupErrors | undefined {
    return state.signUpError;
  }

  @Selector([AuthState])
  static resetPwdInProgress(state: AuthStateModel): boolean {
    return state.resetPwdInProgress;
  }

  @Selector([AuthState])
  static emailAlreadyExist(state: AuthStateModel): boolean {
    return state.signUpError === 'email_already_exist';
  }

  @Selector([AuthState])
  static emailPwdNotFound(state: AuthStateModel): boolean {
    return state.signInError === 'user_pwd_not_found';
  }

  @Selector([AuthState])
  static isLoginIn(state: AuthStateModel): boolean {
    return state.loginInProgress;
  }

  @Selector([AuthState])
  static userLogged(state: AuthStateModel): UserLogged | undefined {
    return state.userLogged;
  }

  @Selector([AuthState])
  /** No token before a sign-in, which is what the state starts at. */
  static accessToken(state: AuthStateModel): string | undefined {
    return state.accessToken;
  }
}
